import { render, staticRenderFns } from "./AssetClass3Picker.vue?vue&type=template&id=fe634fca&"
import script from "./AssetClass3Picker.vue?vue&type=script&lang=ts&"
export * from "./AssetClass3Picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports